// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unit[data-v-fc7cdd4c]{font-size:var(--base-font-size-common);color:var(--base-color-text-primary);margin-left:var(--base-size-4)}", ""]);
// Exports
module.exports = exports;
